import { MarkerF } from '@react-google-maps/api'
import * as React from 'react'
import useDayHistoryStore from '../../../../store/dayHistoryStore.ts'
import dataStore from '../../../../store/dataStore.ts'
import historyStore from '../../../../store/historyStore.ts'
import { getPawIcon } from '../../../map/components/icons.ts'

/**
 * The animated pet marker for Day History mode.
 * Positioned at the current interpolated position from the store.
 * Shows gap indicators when the pet is in a gap period.
 */
export const DayHistoryMarker: React.FC = () => {
    const currentPosition = useDayHistoryStore(s => s.currentPosition)
    const selectedPetId = historyStore(s => s.selectedPetId)
    const pets = dataStore(s => s.pets)

    const pet = pets.find(p => p._id === selectedPetId)

    if (!currentPosition || (currentPosition.lat === 0 && currentPosition.lng === 0)) {
        return null
    }

    const position = { lat: currentPosition.lat, lng: currentPosition.lng }
    const iconColor = pet?.iconColor || '#FF6B6B'

    return (
        <>
            <MarkerF
                position={position}
                icon={getPawIcon(iconColor, google)}
                opacity={currentPosition.inGap ? 0.5 : 1}
            />
        </>
    )
}
